/**
 * HeroEmailInput Component
 * 
 * Email input component for the hero section that allows users to enter their email
 * and navigate to the contact form with the email pre-filled.
 */

"use client";

import { useState } from "react";

export default function HeroEmailInput() {
  const [email, setEmail] = useState("");

  const handleLearnMore = () => {
    // Navigate to contact section and pass email
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      // Store email in sessionStorage for prefill
      if (email) {
        sessionStorage.setItem("prefillEmail", email);
      }
      // Set flag to focus name field after scroll
      sessionStorage.setItem("focusNameField", "true");
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLearnMore();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 max-w-lg">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Enter your email address"
        className="flex-1 px-4 py-3 border border-gray-300 rounded focus:ring-2 focus:ring-gray-900 focus:border-gray-900 bg-white text-gray-900 font-poppins text-base placeholder-gray-500 transition-colors"
      />
      <button
        onClick={handleLearnMore}
        className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded font-semibold text-base transition-colors duration-200 shadow-sm whitespace-nowrap"
      >
        Learn More
      </button>
    </div>
  );
}

